import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { startOfMonth, endOfMonth, isValid, addDays, setMonth } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from 'src/app/modules/entry-control/api-entry-control.service';
import { Facility } from 'src/app/modules/entry-control/interfaces/facility';
import { RoundsConfiguration } from 'src/app/modules/entry-control/interfaces/rounds_configuration';
import { RoundsRecords } from 'src/app/modules/entry-control/interfaces/rounds_records';
import { RoundsType } from 'src/app/modules/entry-control/interfaces/rounds_type';
import { Stores } from 'src/app/modules/entry-control/interfaces/stores';
import { RoundNotificationService } from 'src/app/modules/entry-control/round-notification.service';


@Component({
  selector: 'app-list-scheduled-rounds',
  templateUrl: './list-scheduled-rounds.component.html',
  styleUrls: ['./list-scheduled-rounds.component.css']
})
export class ListScheduledRoundsComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private modal: NgbModal,
    private dateAdapter: DateAdapter<Date>,
    private router:Router,
    private roundNotificationService: RoundNotificationService
  ) { }

  @Input()
  facilityId:number;
  types: RoundsType[];
  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.dateAdapter.setLocale('es'); // Establece el idioma de las fechas a español
    this.mesActual = new Date();
    this.roundNotificationService.roundCreated$.subscribe(round => {
      // Aquí actualizas tu listado de rondas con la nueva ronda recibida
      this.get();
    });
    if(this.facilityId>0){
      this.get(); 
      this.getData();
    }
   
  }

  items: RoundsConfiguration[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  facilityes:Facility[];
  stores:Stores[];
  loading: boolean = false;
  pathDownload: string = null;

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl(),
    active:new UntypedFormControl(0),
    facility_id: new UntypedFormControl(0),
    rounds_type_id: new UntypedFormControl(0),
    irep:new UntypedFormControl(0),
    stores_id: new UntypedFormControl(0),
    order: new UntypedFormControl(1),
    orderType: new UntypedFormControl(1),
  });
  formDelete = new UntypedFormGroup({
    id: new UntypedFormControl(),
    facility_id: new UntypedFormControl(0),
    rounds_type_id: new UntypedFormControl(0),
    idrep:new UntypedFormControl(0),
    deleteAll:new UntypedFormControl(0),
  });

  setDaysStartEnd() {
      this.inicioMes = startOfMonth(this.mesActual);
      this.finMes = endOfMonth(this.mesActual);
    this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
    this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
    this.get();
  }
  get() {
    this.form.get('facility_id')?.setValue(this.facilityId);
    this.api.paginateRecords(this.page, this.form,2).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as RoundsConfiguration[];
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }


  search() {
    this.get();
  }


  mesView: string;
  mesActual: Date;
  fechas: Date[];
  //dia inicial del mes
  inicioMes: Date;

  //dia final del mes
  finMes: Date;
  setStartDay(event: any) {
    this.form.get('start')?.setValue(event.value);
  }

  cambiarMes(delta: number): void {
    this.mesActual = setMonth(this.mesActual, this.mesActual.getMonth() + delta);
    this.mesView = this.mesActual.toISOString();
    this.setDaysStartEnd();
  
  }

  obtenerNombreMes(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    return nombresMeses[mes];
  }
  openModal(md: any, size: string = 'md') {
    this.modal.open(md, {
      size: size,
    });
  }
  openEdit(id: number, md: any) {
    this.idSelected = id;
    this.router.navigate(['/control-ingreso/rondas/editar', id]);
  }
  openDelete(round: RoundsConfiguration, md: any) {
    console.log("llego;",round);
    this.formDelete.patchValue(round);
    this.formDelete.get('deleteAll')?.setValue(0);
    this.modal.open(md, {
      size: 'md',
    });
  }
  delete() {
    this.api.deleteRoundsConfiguration(this.formDelete).subscribe(
      (res) => {
        this.toast.success(
          res.msg,
          'Gestión Rondas'
        );
        this.modal.dismissAll();
        this.get();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }

  getData() {
    this.api.getAllRoundsType().subscribe(
      (response) => {
        this.types = response.data as RoundsType[];
      }
    );
    this.api.getAllStores().subscribe(
      (response) => {
        this.stores = response.data as Stores[];
      }
    );
  }
  setOrder() {
    let valueNow=(this.form.get('order')?.value==1)?2:1;
    this.form.get('order')?.setValue(valueNow);
  }
  generateReport(mdl: any) {
    this.modal.open(mdl);
    // Simular un proceso de generación de reporte
    this.loading = true;
    this.api.generateReport(this.form, 2).subscribe(
      (rs) => {
        console.log("REPORT SUCCESS:", rs);
        this.loading = false;
        this.toast.success(rs.msg);
        let result = rs as any;
        this.pathDownload = result?.path;
      },
      e => {
        console.log("REPORT ERROR:", e);
        this.loading = false;
        this.toast.warning(e.error.mistakes, e.error.msg);
      }
    );
  }
  setRangeCalendar() {
    if (isValid(this.form.get('start')?.value) && isValid(this.form.get('end')?.value)) {
      this.inicioMes = addDays(new Date(this.form.get('start')?.value), 1);
      this.finMes = addDays(new Date(this.form.get('end')?.value), 1);
      this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
      this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
      this.get();
    }
  }
}

